import { ApolloClient, ApolloQueryResult, DocumentNode, InMemoryCache, NormalizedCacheObject, OperationVariables, QueryHookOptions, QueryOptions, QueryResult, TypedDocumentNode, useQuery } from "@apollo/client";
import { Locale, StoreKey } from "@common/constans";
import { Culture } from "@core/index";
import Storage from "@service/Storage";

let client: ApolloClient<NormalizedCacheObject>;

export function getApolloClient() {
    return client;
}

export function setApolloClient(uri: string) {
    if (!client)
        client = new ApolloClient({
            uri,
            cache: new InMemoryCache({
                addTypename: false
            })
        });
}

export function useApolloQuery<TData = any, TVariables = OperationVariables>(query: DocumentNode | TypedDocumentNode<TData, TVariables>, options?: QueryHookOptions<TData, TVariables>): QueryResult<TData, TVariables> {
    const culture = Culture.getLocale()?.code;
    const usLocale = Culture.getLocale(Locale.en);
    return useQuery<TData, TVariables>(query, {
        ...options, context: {
            ...options?.context,
            headers: {
                "accept-language": usLocale.code
            }
        }, variables: Object.assign({ culture, status: "PUBLISHED" }, options?.variables)
    });
};

export function apolloQuery<T = any, TVariables = OperationVariables>(query: DocumentNode | TypedDocumentNode<T, TVariables>, options?: QueryOptions<TVariables, T>): Promise<ApolloQueryResult<T>> {
    const culture = Culture.getLocale()?.code || Storage.get<string>(StoreKey.Culture) || "en-US";
    return client.query({
        ...options, context: {
            ...options?.context,
            headers: {
                "accept-language": "en-US"
            }
        }, query, variables: Object.assign({ culture, status: "PUBLISHED" }, options?.variables)
    });
}